<template>
  <div class="querydept_main">
    <ball></ball>
    <div class="nav">
      <van-nav-bar
        title="科室类别"
        left-arrow
        left-text="返回"
        @click-left="onClickLeft"
      />
    </div>
    <div class="body">
      <div>
        <!--  -->
        <van-sidebar v-model="activeKey" type="primary" class="dypeList">
          <van-sidebar-item
            v-for="(item, index) in dypeList"
            :key="index"
            :title="item.deptName"
            @click="
              clickflag
                ? getregLevelIdInfo(item.deptId, index, item.deptName, item)
                : NO_getregLevelIdInfo(item.deptId, index, item.deptName)
            "
          />
        </van-sidebar>
      </div>
      <div class="querydept_cell" v-if="Cflag">
        <div v-if="clickflag">
          <div v-if="emptyflag">
            <van-empty
              image="https://account.kmmds.top/datainfo_pic/error.png"
              description="该科室暂无排班"
            />
          </div>
          <van-cell
            v-else
            v-for="(item, key) in reglevelList"
            :key="key"
            is-link
            class="cellltem"
            :title="key"
            @click="godocLIst(item, key)"
          />
        </div>
        <div v-else>
          <van-cell
            v-for="(item, key) in reglevelList"
            :key="key"
            is-link
            class="cellltem"
            :title="item.showName"
            @click="
              godetail_No(item.regLevelName, item.regLevelId, item.regFee)
            "
          />
        </div>
      </div>
      <div class="querydept_cell" v-else>
        <div>
          <div v-if="empty_D_flag">
            <van-empty
              image="https://account.kmmds.top/datainfo_pic/error.png"
              description="该科室暂无排班"
            />
          </div>
          <div class="D_btn_right" v-else>
            <div class="aa"></div>
            <van-button
              color="#5B8DF6"
              class="D_btn"
              size="large"
              @click="godetails_d()"
              >挂号</van-button
            >
          </div>
          <!-- <van-cell
            v-else
            class="cellltem"
            title="预约挂号"
          /> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Nav from "./../../components/nav.vue";
import { Dialog } from "vant";
import setOptions from "@/mixins/setOption";
export default {
  mixins: [setOptions],
  data() {
    return {
      //单元格点击事件  true 有排班  false没排班
      clickflag: null,
      regfre: "",
      Cflag: true,
      deptflag: false,
      name: "",
      isFirstEnter: false,
      navTitle: "科室列表",
      activeKey: 0,
      index: 0,
      dypeList: [],
      depy_type: "",
      method_depy_type: [],
      reglevelList: [],
      emptyflag: false,
      dept_id: null,
      empty_D_flag: false,
      //挂号排班类型
      register_sched: "",
      // 挂号级别
      register_level: "",
      wx_pub_id: "",
    };
  },
  components: {
    Nav,
  },
  mounted() {
    // this.getDeptList();
    this.getrerinfo();
  },
  methods: {
    onClickLeft() {
      this.$router.push("/index");
    },
    //跳转C版无排班挂号页
    godetail_No(regLevelName, regLevelId, regFee) {
      this.$router.push({
        path: "/no_details",
        query: {
          registerInfo: {
            dept_deptId: this.method_depy_type.deptId,
            dept_name: this.method_depy_type.deptName,
            regLevelName,
            regLevelId,
            regFee,
          },
        },
      });
    },
    //跳转D版
    godetails_d() {
      this.$router.push({
        path: "/details_ymzyy",
        query: {
          deptid: this.method_depy_type.deptId,
          dept_type: this.method_depy_type,
          register_level: this.register_level,
          regfre: this.regfre,
        },
      });
    },
    //判断版本和排版类型
    async getrerinfo() {
      try {
        this.$showLoad();
        let url = "/hospitalconf/index/getdictionaries";
        await this.$axios_request.axios_request_body(
          "nodeserver",
          url,
          "POST",
          null,
          (data) => {
            //  console.log(data.data)
            this.wx_pub_id = data.data.wx_pub_id;
            // 挂号级别
            this.register_level = data.data.register.register_level;
            //  排班
            this.register_sched = data.data.register.register_sched;
            //  挂号类型
            this.register_type = data.data.register.register_type;
            this.getDeptList();
            if( this.wx_pub_id=="1012"){
              this.showDialog()
            }
            // if (register_sched == "Y") {
            //   //通过科室ID获取该科室下的挂号级别列表
            //   this.getDeptList();
            // } else if (this.register_sched == "N") {
            //   //显示挂号预约按钮
            //   //判断是否有挂号级别===》
            //   if (this.register_level == "Y") {
            //     this.getDeptList();
            //   } else if (this.register_level == "N") {
            //     this.regfre = data.data.register.price;
            //     this.Cflag = false;
            //     this.getDeptList();
            //   }
            // }
            this.$hideLoad();
          }
        );
      } catch (error) {
        // console.log(error);
        this.$hideLoad();
      }
    },
    //跳转下一页 传递参数
    godocLIst(item, key) {
      // console.log(this.name)
      // console.log(key)
      this.$router.push({
        path: "/schedulhead",
        query: {
          dept_deptId: this.method_depy_type.deptId,
          dype_type_name: key,
          dype_type_key: item,
          dypename: this.name,
        },
      });
      // console.log(dept_deptId)
    },
    //获取挂号类型和id
    async getregLevelIdInfo(deptId, index, name, item) {
      this.dept_id = deptId;
      this.method_depy_type = this.dypeList[index];
      this.name = name;
      if (item.cost) {
        this.regfre = item.cost;
      }
      //  console.log(this.name)
      //  console.log(deptId)
      try {
        this.$showLoad();
        let url = "/register/queryschedulheadBydeptId";
        let R_data = { deptId: deptId };
        // console.log(R_data)
        await this.$axios_request.request_data(
          "nodeserver",
          url,
          "POST",
          R_data,
          async (data) => {
            this.reglevelList = data.data;
            if (this.reglevelList == null) {
              this.empty_D_flag = true;
            } else {
              this.empty_D_flag = false;
            }
            // console.log(this.reglevelList)
            // console.log(!this.reglevelList['主任医师号'],!this.reglevelList['副主任医师号'],!this.reglevelList['急诊号'],!this.reglevelList['普通挂号'])

            if (
              !this.reglevelList["主任医师号"] &&
              !this.reglevelList["副主任医师号"] &&
              !this.reglevelList["急诊号"] &&
              !this.reglevelList["普通挂号"]
            ) {
              this.emptyflag = true;
            } else {
              this.emptyflag = false;
            }
            // if(!(this.reglevelList&&this.reglevelList['普通挂号'])){
            //   this.dypeList.splice(index,1);
            //   await this.getregLevelIdInfo(this.dypeList[0].deptId,0);
            //   }
            this.$hideLoad();
          }
        );
      } catch (error) {
        // console.log(error);
        this.$hideLoad();
      }
    },
    showDialog() {
      Dialog.alert({
        title: "清廉承诺",
        messageAlign:"left",
        message:
          "为规范医疗秩序，严厉整治打击医疗乱象，我们承诺：\n一、不收红包。\n二、不收受礼品。\n三、不进行术中加价。\n四、不指定院外购药。\n五、不骗取医疗保障基金。\n六、不接受病人及亲属吃请。\n七、不进行过度检查、过度诊疗。\n八、不违规超量、超限制开具药品或耗材。\n九、不重复收费、捆绑收费、串换收费、超量收费。\n十、不参与供应商的推销活动和虚假医疗广告宣传。我们真诚接受广大人民群众和社会各界的监督。\n弥勒市卫生健康局监督举报电话：\n<span style='color:red'>0873—6122360，08733029379</span>\n弥勒市纪委市监委监督举报方式：\n电话举报：<span style='color:red'>0873—6122585</span>\n来信举报：弥勒市纪委市监委信访室  邮编：652399\n来访举报：弥勒市行政中心1—18室"
      }).then(() => {
        // on close
      });
    },
    //无排班挂号级别
    async NO_getregLevelIdInfo(deptId, index, name) {
      this.dept_id = deptId;
      this.method_depy_type = this.dypeList[index];
      this.name = name;
      // console.log(this.method_depy_type)
      try {
        this.$showLoad();
        let url = "/register/queryallreglevel";
        // console.log(R_data)
        await this.$axios_request.request_data(
          "nodeserver",
          url,
          "POST",
          null,
          async (data) => {
            this.reglevelList = data.data.data.data;
            this.reglevelList = this.reglevelList.filter(
              (item) =>
                (item.regLevelName != "免挂号") &
                (item.regLevelName != "急诊号")
            );
            if(this.wx_pub_id == "1020"&&this.dept_id=="1176"){
               this.reglevelList=this.reglevelList.filter(item=>{
                 return item.regLevelName=="主任医师号"
               });
            }
            if(this.wx_pub_id == "1020"&&this.dept_id=="1205"){
               this.reglevelList=this.reglevelList.filter(item=>{
                 return item.regLevelName=="主任医师号"
               });
            }
            //  &item.regLevelName!="副主任医师号" &item.regLevelName!="主任医师号" &item.regLevelName!="急诊号")
            if (this.reglevelList == null) {
              this.empty_D_flag = true;
            } else {
              this.empty_D_flag = false;
            }
         
            this.$hideLoad();
          }
        );
      } catch (error) {
        // console.log(error);
        this.$hideLoad();
      }
    },
    async getDeptList() {
      //获取科室列表
      try {
        this.$showLoad();
        // this.isLoad = true
        let url = "/register/querydept";
        await this.$axios_request.axios_request_body(
          "nodeserver",
          url,
          "POST",
          null,
          (data) => {
          
            if (this.wx_pub_id == "1012") {
              this.dypeList = data.data.data.filter((item) => {
                // console.log(item)
                return item.deptId != "183";
              });
            } else if (this.wx_pub_id == "1013") {
              this.dypeList = data.data.data.filter((item) => {
                // console.log(item)
                return (
                  item.deptId == "4" ||
                  item.deptId == "56" ||
                  item.deptId == "31"
                );
              });
            } else if (this.wx_pub_id == "1020") {
              let a = data.data.data.filter((item) => {
                // console.log(item)
                return item.deptId == "1176";
              });
               let b = data.data.data.filter((item) => {
                // console.log(item)
                return item.deptId != "1176" &&item.deptId!="926" &&item.deptId!="1135";
               
              });
               this.dypeList=[...a,...b]
            }  else if (this.wx_pub_id == "3575") {
              this.dypeList = data.data.data.filter((item) => {
                // console.log(item)
                return item.deptId != "2" &&item.deptId !="59";
              });
              console.log(this.dypeList)
            }else {
              this.dypeList = data.data.data;
            }
            // console.log( this.dypeList)
            // console.log(this.dypeList)
            /**
             挂号排班类型
             @register_sched
             挂号级别
              @register_level
             */
            if (this.register_sched == "Y") {
              this.clickflag = true;
              this.getregLevelIdInfo(
                this.dypeList[0].deptId,
                0,
                this.dypeList[0].deptName,
                this.dypeList[0]
              );
            } else if (this.register_sched == "N") {
              this.clickflag = false;
              //显示挂号预约按钮
              //判断是否有挂号级别===》
              if (this.register_level == "Y") {
                this.NO_getregLevelIdInfo(
                  this.dypeList[0].deptId,
                  0,
                  this.dypeList[0].deptName
                );
              } else if (this.register_level == "N") {
                this.clickflag = true;
                this.getregLevelIdInfo(
                  this.dypeList[0].deptId,
                  0,
                  this.dypeList[0].deptName,
                  this.dypeList[0]
                );
                this.Cflag = false;
              }
            }
            this.$hideLoad();
          }
        );
      } catch (error) {
        // console.log(error);
        this.$hideLoad();
      }
    },
  },
};
</script>

<style  lang="scss" scoped>
.van-sidebar-item--select::before {
  background-color: #5b8df6;
}
.querydept_main {
  display: flex;
  flex-direction: column;
  max-height: 100vh;
  max-width: 100vw;
}
.body {
  flex: 1;
  display: flex;
  flex-direction: row;
  .dypeList {
    max-height: 94vh;
    width: 28vw;
    line-height: 50px;
  }
  .dis {
    font-size: 14px;
    line-height: 35px;
    color: #7f8c8d;
    text-align: left;
  }
  .querydept_cell {
    display: flex;
    flex-direction: column;
    width: 80vw;
    height: 90vh;

    .D_btn_right {
      height: 85vh;
      .aa {
        height: 85vh;
      }
    }
    .cellltem {
      line-height: 35px;
      text-align: center;
    }
  }
}
</style>